/**
 * EMBER & PALM — shared business facts and assets.
 * Genuine Angkor photography leads; Palm Ember Gold is restrained; booking is dominant.
 */
export const SITE = {
  name: "ANGKOR Cambodian Flavours",
  contextualName: "ANGKOR Cambodian Flavours — Restaurant & Bar",
  address: "389 Spencer Street, West Melbourne VIC 3003",
  phoneDisplay: "(03) 7034 8353",
  phone: "+61370348353",
  email: "info@angkorflavours.com.au",
  eventsEmail: "info@angkorflavours.com.au",
  eventsPackage: "/manus-storage/angkor-events-packages-v3_939d541c.pdf",
  booking: "https://reserve.oddle.me/en_AU/angkorcafe",
  directOrder:
    "https://order-food.hivive.com.au/angkor-caf-&-restaurant-/table/onlineorder",
  uberEats:
    "https://www.ubereats.com/au/store/angkor-cambodian-flavours-spencer-st/bFMzZ1BqU8aMNxLgKMPGAQ?ps=1",
  directions:
    "https://maps.google.com/?q=389+Spencer+Street+West+Melbourne+VIC+3003",
  reviews: "https://g.page/r/CX0QxNbmB7mcEAE/review",
  instagram: "https://www.instagram.com/angkor.21/",
  facebook: "https://www.facebook.com/angkorcafe21/",
  tiktok: "https://www.tiktok.com/@angkorflavours",
  rating: "4.7",
  reviewCount: "467",
  reviewChecked: "27 September 2026",
  geo: { lat: -37.8113353, lng: 144.9503465 },
  hours: [
    ["Monday", "Closed"],
    ["Tuesday", "11:30 am–3:00 pm · 4:30 pm–9:30 pm"],
    ["Wednesday", "11:30 am–3:00 pm · 4:30 pm–9:30 pm"],
    ["Thursday", "11:30 am–3:00 pm · 4:30 pm–9:30 pm"],
    ["Friday", "11:30 am–9:30 pm"],
    ["Saturday", "12:00 pm–9:30 pm"],
    ["Sunday", "4:30 pm–9:30 pm"],
  ],
  images: {
    mark: "/manus-storage/angkor-logo-refined_57435d75.webp",
    markCompact: "/manus-storage/angkor-logo-256_0b7f3527.webp",
    markPng: "/android-chrome-512x512.png",
    heroTexture: "/manus-storage/hero-texture-1600_cd89e744.webp",
    heroTextureSmall: "/manus-storage/hero-texture-960_17138fa2.webp",
    heroTextureMobile: "/manus-storage/hero-texture-640_69f6d097.webp",
    parchment: "/manus-storage/warm-parchment-fibre_fcee61b7.jpg",
    goldDetail: "/manus-storage/palm-edge-gold-detail_53040e22.jpg",
    interior:
      "/manus-storage/angkor-restaurant-interior-west-melbourne_b573dae6.webp",
    interior480:
      "/manus-storage/angkor-restaurant-interior-west-melbourne-480_91d4e0c1.webp",
    interior640:
      "/manus-storage/angkor-restaurant-interior-west-melbourne-640_b40e8eeb.webp",
    interior800:
      "/manus-storage/angkor-restaurant-interior-west-melbourne-800_d96d9387.webp",
    interior1200:
      "/manus-storage/angkor-restaurant-interior-west-melbourne-1200_6c8f4b90.webp",
    atmosphere:
      "/manus-storage/angkor-restaurant-atmosphere-west-melbourne_aa44448c.webp",
    fishAmok: "/manus-storage/fish-amok-premium_857a8cbd.webp",
    fishAmokFloat: "/manus-storage/fish-amok-floating-bowl-240_d181b8b4.webp",
    fishAmok480: "/manus-storage/fish-amok-premium-480_8a07d86f.webp",
    fishAmok640: "/manus-storage/fish-amok-640_b315b7a1.webp",
    fishAmok960: "/manus-storage/fish-amok-960_06be84b6.webp",
    fishAmokRice: "/manus-storage/fish-amok-menu-landscape_dec2ca88.webp",
    beefLocLac: "/manus-storage/beef-loc-lac-premium_c84dd63b.webp",
    beefLocLac480: "/manus-storage/beef-loc-lac-premium-480_78f2ce7e.webp",
    beefLocLac640: "/manus-storage/beef-loc-lac-640_bff749be.webp",
    beefLocLac960: "/manus-storage/beef-loc-lac-960_84e99c2a.webp",
    grandmothersDish: "/manus-storage/grandmothers-dish-premium_329e9204.webp",
    grandmothersDish480:
      "/manus-storage/grandmothers-dish-premium-480_b5805cc5.webp",
    grandmothersDish640: "/manus-storage/grandmothers-dish-640_a4c662df.webp",
    grandmothersDish960: "/manus-storage/grandmothers-dish-960_f4064870.webp",
    neri: "/manus-storage/neri-angkor-story_5eb255ff.webp",
    angkorTropical: "/manus-storage/angkor-tropical-premium_467037aa.webp",
    angkorTropical480: "/manus-storage/angkor-tropical-480_ccd239d1.webp",
    angkorTropical720: "/manus-storage/angkor-tropical-720_cead9400.webp",
    angkorTropical800: "/manus-storage/angkor-tropical-800_52ecb2e7.webp",
    bbqBeef: "/manus-storage/bbq-beef-premium_1c2f5918.webp",
    cambodianCurry: "/manus-storage/cambodian-curry-premium_23eefa20.webp",
    korKoh: "/manus-storage/beef-stew-kor-koh-angkor_d9df2a1d.webp",
    khmerGrill:
      "/manus-storage/khmer-grill-sharing-platter-angkor_3fd18469.webp",
    betelLeaf: "/manus-storage/betel-leaf-prawn-angkor_64cea8a7.webp",
    salad:
      "/manus-storage/green-mango-salad-angkor-cambodian-flavours_7f2d0095.webp",
    seafood: "/manus-storage/kampot-pepper-seafood-rice-angkor_5411d20f.webp",
    coffee: "/manus-storage/cambodian-coffee-angkor_840dd93f.webp",
    icedCoffee: "/manus-storage/iced-cambodian-coffee-angkor_c3d9da6c.webp",
    dessert: "/manus-storage/black-sticky-rice-dessert-angkor_fc5b177d.webp",
    curryPasteSingle:
      "/manus-storage/angkor-amok-curry-paste-280g-single-jar_eb8ef593.webp",
    curryPasteSingle320:
      "/manus-storage/angkor-amok-curry-paste-280g-single-jar-320_5f68ecbf.webp",
    curryPasteSingle128:
      "/manus-storage/angkor-amok-curry-paste-280g-single-jar-128_728e1f9c.webp",
    curryPasteSingle640:
      "/manus-storage/angkor-amok-curry-paste-280g-single-jar-640_1aa17c61.webp",
    curryPasteSingle960:
      "/manus-storage/angkor-amok-curry-paste-280g-single-jar-960_7465b733.webp",
    curryPasteSingle768:
      "/manus-storage/angkor-amok-curry-paste-280g-single-jar-768_8b870288.webp",
    curryPasteLifestyle:
      "/manus-storage/angkor-amok-curry-paste-280g-lifestyle_4159d282.webp",
    curryPasteLifestyle320:
      "/manus-storage/angkor-amok-curry-paste-280g-lifestyle-320_c9e236c0.webp",
    curryPasteLifestyle128:
      "/manus-storage/angkor-amok-curry-paste-280g-lifestyle-128_6ec4c52b.webp",
    curryPasteLifestyle640:
      "/manus-storage/angkor-amok-curry-paste-280g-lifestyle-640_a1340d9a.webp",
    curryPasteLifestyle960:
      "/manus-storage/angkor-amok-curry-paste-280g-lifestyle-960_1a855129.webp",
    curryPasteLifestyle768:
      "/manus-storage/angkor-amok-curry-paste-280g-lifestyle-768_48fb0736.webp",
    curryPasteServing:
      "/manus-storage/angkor-amok-curry-paste-280g-fish-amok-serving_13a1ca77.webp",
    curryPasteServing320:
      "/manus-storage/angkor-amok-curry-paste-280g-fish-amok-serving-320_4a641826.webp",
    curryPasteServing128:
      "/manus-storage/angkor-amok-curry-paste-280g-fish-amok-serving-128_6e21c143.webp",
    curryPasteServing640:
      "/manus-storage/angkor-amok-curry-paste-280g-fish-amok-serving-640_7eb546f2.webp",
    curryPasteServing960:
      "/manus-storage/angkor-amok-curry-paste-280g-fish-amok-serving-960_138f4997.webp",
    curryPasteServing768:
      "/manus-storage/angkor-amok-curry-paste-280g-fish-amok-serving-768_c28f6f9b.webp",
  },
} as const;

export const dinnerMenu = [
  {
    name: "Signatures",
    items: [
      {
        name: "Fish Amok",
        description:
          "Fragrant steamed coconut curry with aromatic kroeung, mackerel, Chinese broccoli and peanuts.",
        price: "$34.50",
        tag: "Signature",
      },
      {
        name: "My Grandmother’s Dish",
        description:
          "Juicy marinated free-range chicken, mixed salad, mint and grandmother’s dipping sauce.",
        price: "$29.60",
        tag: "Family recipe",
      },
      {
        name: "Beef Stew ‘Kor Koh’",
        description:
          "Slow-cooked beef brisket with five-spice comfort, carrots, onion, celery and French baguette. Add flat rice noodles +$3.90.",
        price: "$28.90",
        tag: "Slow-cooked",
      },
    ],
  },
  {
    name: "Start to Share",
    items: [
      [
        "Cambodian Fish Cakes",
        "Green beans, sweet chilli dipping sauce · 2 pieces",
        "$14.90",
      ],
      [
        "Betel Leaf",
        "Prawns, peanuts, shallots, lime dressing · 2 pieces",
        "$15.50",
      ],
      [
        "Spring Rolls",
        "Vegetable filling, sweet chilli sauce · 5 pieces",
        "$11.50",
      ],
      ["Prawn Wontons", "Crispy or steamed, hoisin sauce · 8 pieces", "$13.90"],
      [
        "Marinated Beef Skewers",
        "Grilled, soy and chilli sauce · 4 pieces",
        "$14.90",
      ],
      [
        "Marinated Chicken Skewers",
        "Grilled, soy and chilli sauce · 4 pieces",
        "$14.00",
      ],
    ].map(([name, description, price]) => ({ name, description, price })),
  },
  {
    name: "Fresh & Vibrant",
    items: [
      [
        "Cambodian Papaya Salad",
        "Green papaya, carrot, shallots, peanuts, fish sauce and lime. Vegan option available.",
        "$21.90",
      ],
      [
        "Green Mango Salad",
        "Green mango, carrot, herbs, prawns, sweet and sour dressing and peanuts. Add grilled barramundi +$10.50.",
        "$22.90",
      ],
      [
        "Banana Blossom Salad",
        "Spiced banana blossom, carrot, Asian herbs and crushed peanuts. Add chicken or pork +$7.00.",
        "$23.90",
      ],
    ].map(([name, description, price]) => ({ name, description, price })),
  },
  {
    name: "Main Favourites",
    items: [
      [
        "Beef Loc Lac",
        "Wok-seared marinated beef, mixed salad, onions and fried egg.",
        "$32.90",
      ],
      [
        "Traditional Red Curry",
        "Cambodian kroeung curry, coconut broth, sweet potatoes, eggplant, green beans and herbs. Choice of tofu or chicken.",
        "$25.50",
      ],
      [
        "Kampot Pepper Seafood",
        "King prawns and calamari with garlic, carrots, spring onion and Kampot pepper.",
        "$32.90",
      ],
      [
        "Lemongrass Fried Rice",
        "Homemade kroeung, egg, omelette and seasonal vegetables. Choose tofu; chicken +$3.50; beef +$4.00.",
        "$23.50",
      ],
      [
        "Grilled Pork Neck",
        "Pickled carrot, cucumber, herbs and soy chilli sauce. Best with jasmine rice +$5.00.",
        "$28.90",
      ],
      [
        "BBQ Beef Steak",
        "300g chargrilled rump cap, mixed vegetables and black pepper salt with lemon.",
        "$36.90",
      ],
    ].map(([name, description, price]) => ({ name, description, price })),
  },
  {
    name: "Sweets",
    items: [
      [
        "Sticky Rice with Mango",
        "Coconut rice, mango and toasted mung beans",
        "$16.00",
      ],
      [
        "Black Rice Pudding",
        "Black rice, coconut cream and sesame seeds",
        "$15.90",
      ],
      [
        "Homemade Coconut Ice Cream",
        "Served with a crispy coconut roll",
        "$14.50",
      ],
    ].map(([name, description, price]) => ({ name, description, price })),
  },
];

export const mealAddOns = [
  ["Steamed Jasmine Rice", "$5.00"],
  ["Brown Rice", "$6.00"],
  ["Asian Roti", "2 pieces · $6.90"],
  ["Chinese Broccoli", "$14.90"],
  ["Fried Egg", "$3.50"],
  ["Extra Homemade Sauce", "$3.00"],
  ["Extra Chilli Sauce", "$3.00"],
] as const;

export const lunchMenu = [
  [
    "Fish Amok Rice Bowl",
    "Kroeung, mackerel, Chinese broccoli and peanuts over jasmine rice with house salad.",
    "$22.90",
  ],
  [
    "Beef Loc Lac Bowl",
    "Wok-seared beef, mixed salad, onions and fried egg over jasmine rice with house salad.",
    "$22.90",
  ],
  [
    "Grandmother’s Chicken Bowl",
    "Marinated chicken, mixed salad, mint and grandmother’s dipping sauce over jasmine rice with house salad.",
    "$19.90",
  ],
  [
    "Lemongrass Fried Rice",
    "House-made kroeung, egg, omelette and vegetables; tofu or chicken.",
    "$18.90",
  ],
  [
    "Red Curry Bowl",
    "Kroeung curry with tofu or chicken, coconut broth, sweet potatoes, eggplant, green beans and herbs, with jasmine rice.",
    "$19.90",
  ],
  [
    "Grilled Pork Neck Rice",
    "Chargrilled pork neck, pickled carrot, cucumber, herbs and soy chilli sauce over jasmine rice with house salad.",
    "$21.90",
  ],
].map(([name, description, price]) => ({ name, description, price }));

export const verifiedReviews = [
  {
    name: "Anita Suster",
    quote:
      "Flavoursome and fresh. Sweet service — an easy recommendation for anyone wanting to experience Cambodian food.",
  },
  {
    name: "Susan Piccoli",
    quote:
      "One of the best curry dishes I have eaten. Lovely lemongrass flavours, fresh ingredients and warm service.",
  },
  {
    name: "Emily Rose",
    quote:
      "Amazing food, incredibly friendly service and a convenient location. I definitely recommend it.",
  },
];

export function trackEvent(name: string, data?: Record<string, string>) {
  const tracker = (
    window as Window & {
      umami?: {
        track: (event: string, details?: Record<string, string>) => void;
      };
    }
  ).umami;
  tracker?.track(name, data);
}
